import { resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VChart = _resolveComponent("VChart")!

  return (_openBlock(), _createBlock(_component_VChart, {
    class: "chart",
    style: _normalizeStyle({ height: $setup.state.height, width: $setup.state.width }),
    option: $setup.state.selectOption,
    onClick: $setup.handleChartClick
  }, null, 8, ["style", "option", "onClick"]))
}